module.exports = __webpack_public_path__ + "media/components/maps/incidents/icons/violent_conflict-2bbe27f596271fa39482091b2e0aef36.png";